module.exports = __webpack_public_path__ + "static/img/20012 (4).1862bc2.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20012 (4).webp
// module id = r7Y9
// module chunks = 14